module.exports = __webpack_public_path__ + "img/Jeremiah-Chiu---Zoom-Room-1.07d485a7.jpg";